module.exports = __webpack_public_path__ + "static/pastry_academy_og_image-4b1064ea59689e2f0320127df35ab6d8.jpg";